import React, { useEffect, useState } from "react";
import { useLang } from "@/context/LangContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import api from "@/lib/api";
import { format, parseISO } from "date-fns";

function Board({ audience }) {
  const { t, lang } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => {
    try { const { data } = await api.get(`/announcements?audience=${audience}`); setItems(data); } catch(e){}
  })(); }, [audience]);

  if (!items.length) return <p className="py-12 text-center text-[hsl(var(--muted-foreground))]">{t.announcements.empty}</p>;

  return (
    <ul data-testid={`announcements-list-${audience}`} className="divide-y divide-[hsl(var(--border))]">
      {items.map((a) => (
        <li key={a.id} data-testid={`announcement-${a.id}`} className="py-6 md:py-8 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 hover:bg-[hsl(var(--muted))]/40 -mx-2 px-2 rounded-lg transition-colors">
          <div className="md:col-span-2 text-xs tracking-[0.2em] uppercase text-[hsl(var(--muted-foreground))]">
            {format(parseISO(a.created_at), "MMM dd, yyyy")}
          </div>
          <div className="md:col-span-10">
            <h3 className="font-display text-xl md:text-2xl tracking-tight font-medium">
              {lang === "zh" && a.title_zh ? a.title_zh : a.title}
            </h3>
            <p className="mt-2 text-[hsl(var(--muted-foreground))]">
              {lang === "zh" && a.content_zh ? a.content_zh : a.content}
            </p>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default function AnnouncementsSection() {
  const { t } = useLang();
  return (
    <section id="announcements" data-testid="announcements-section" className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 border-t border-[hsl(var(--border))]">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
        <div>
          <p className="text-xs tracking-[0.25em] text-[hsl(var(--muted-foreground))]">{t.announcements.eyebrow}</p>
          <h2 className="font-display text-3xl md:text-5xl tracking-tight font-medium mt-3">{t.announcements.title}</h2>
        </div>
        <p className="text-sm text-[hsl(var(--muted-foreground))] max-w-md">{t.announcements.sub}</p>
      </div>

      <Tabs defaultValue="public">
        <TabsList data-testid="announcements-tabs" className="bg-[hsl(var(--muted))] p-1 rounded-full h-auto">
          <TabsTrigger value="public" data-testid="ann-tab-public" className="rounded-full data-[state=active]:bg-white data-[state=active]:shadow-sm px-5 py-2">{t.announcements.tab_public}</TabsTrigger>
          <TabsTrigger value="staff" data-testid="ann-tab-staff" className="rounded-full data-[state=active]:bg-white data-[state=active]:shadow-sm px-5 py-2">{t.announcements.tab_staff}</TabsTrigger>
          <TabsTrigger value="students_parents" data-testid="ann-tab-students" className="rounded-full data-[state=active]:bg-white data-[state=active]:shadow-sm px-5 py-2">{t.announcements.tab_students}</TabsTrigger>
        </TabsList>
        <TabsContent value="public" className="mt-8"><Board audience="public" /></TabsContent>
        <TabsContent value="staff" className="mt-8"><Board audience="staff" /></TabsContent>
        <TabsContent value="students_parents" className="mt-8"><Board audience="students_parents" /></TabsContent>
      </Tabs>
    </section>
  );
}
